import QuickBtnGroup from "../../../components/QuickBtnGroup/QuickBtnGroup";

import $ from 'jquery';
import _ from 'underscore';
import render from "../../../utilities/render";
import { setOptionsForSelect } from "../../../utilities/selectorHelpers";
import { isBlank } from "../../../utilities/general";
import typeAheadSource from "../../../utilities/typeAheadSource";

export function displayCustomReporting(mainEl, appendTo, params, paramDetails, values={}, isScheduler=false) {
  params.content.forEach(function(param) {
    let value = values[param.crpKey];

    if (param.crpKey === 'DATE_RANGE') {
      renderDateRangeParam(appendTo, values['DATE_RANGE'], values['DATE_RANGE1'], values['DATE_RANGE2'], ((isScheduler) ? false : true));
    } else if (param.crpKey === 'WAREHOUSE' || param.crpKey === 'DESTINATION_FACILITY' || param.crpKey === 'RMA_STATUS' || param.crpKey === 'RMA_ADDRESS' || param.crpKey === 'AGING_DAYS' || param.crpKey === 'WAREHOUSE_REQ' || param.crpKey === 'ATT_WS_TYPES' || param.crpKey === 'ATT_DESTINATIONS'
      || param.crpKey === 'WAREHOUSE_BREAKDOWN' || param.crpKey === 'INCLUDE_INVENTORY' || param.crpKey === 'ITEM_STATUS' || param.crpKey === 'RETAILER_ID_REQ' || param.crpKey === 'STOCK_LEVEL') {
      let crpDetails = getCrpDropDownDetails(mainEl, param.crpKey, paramDetails);
      let hasAll = true;

      if(param.crpKey === 'WAREHOUSE_REQ'){
        hasAll = false;

        if(isBlank(value) && crpDetails.data && crpDetails.data.length > 0){
          value = crpDetails.data[0].facCode || '';
        }
      }

      if(param.crpKey === 'RETAILER_ID_REQ'){
        hasAll = false;
      }
      console.log('Value is: ', value);

      renderDropDownParam(appendTo, param.crpKey, crpDetails.detail, crpDetails.data, crpDetails.keyName, 
        crpDetails.valName, value, hasAll);
    } else if (param.crpKey === 'DATE_RANGE_TYPE') {
      renderDateRangeTypeParam(appendTo, param.crpKey, paramDetails[param.crpKey], mainEl.data('date-range-types'), value);
    } else if (param.crpKey === 'RMA_LAST_NAME' || param.crpKey === 'RMA_EMAIL') {
      renderInputParam(appendTo, param.crpKey, paramDetails[param.crpKey], value);
    } else if (param.crpKey === 'RMA_NUMBER' || param.crpKey === 'TRACKING_NUMBER' || param.crpKey === 'ORDER_NUMBER' || param.crpKey === 'FXO_STORE') {
      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], { tags:true }, [], '', '', value);
    } else if (param.crpKey === 'CAS_SKUS') {
      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('cas-skus'), 'cdmValue', 'cdmValue', value);
    } else if (param.crpKey === 'RETAILER_NAME') {
      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('retailers'), 'rtlName', 'rtlName', value);
    } else if (param.crpKey === 'CHANNELS') {
      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('channels'), 'parId', 'parName', value);
    } else if (param.crpKey === 'ADDRESS_TYPES') {
      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('address-types'), 'cdmValue', 'cdmMeaning', value);
    } else if (param.crpKey === 'CREDIT_TYPES') {
      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('credit-types'), 'cdmValue', 'cdmMeaning', value);
    } else if (param.crpKey === 'PRODUCTS') {
      renderRemoteSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey],
        {url:mainEl.data('product-typeahead-url'), data: configureDataCallback({paramKey: 'likeSku'}), minLengthOfChars:3}, value);
    } else if (param.crpKey === 'SHIPMENTS') {
      renderRemoteSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey],
        {url:mainEl.data('shipment-typeahead-url'), data: configureDataCallback({paramKey: 'likeShipmentId'}), minLengthOfChars:3}, value);
      } else if (param.crpKey === 'ORDER_STATUS') {
        renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('order-status'), 'cdmValue', 'cdmValue', value);
      } else if (param.crpKey === 'WORK_ORDER_STATUS') {
        renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('work-order-status'), 'cdmValue', 'cdmValue', value);
        } else if (param.crpKey === 'ATT_FXO_STORE' || param.crpKey === 'ATT_BAN_NUMBER' || param.crpKey === 'ATT_REC_ID' ||param.crpKey === 'ITEM_MODEL' || param.crpKey === 'RECEIPT_SERIAL_NUMBER' || param.crpKey === 'RECEIPT_ID') {
      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], { tags:true }, [], '', '', value);
    }  else if (param.crpKey === 'INBOUND_SHIPMENT_STATUS') {
      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('asn-status'), 'cdmValue', 'cdmValue', value);
    } else if (param.crpKey === 'CATEGORY') {
      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('item-categories'), 'catId', 'catName', value);
    } else if (param.crpKey === 'UPC') {
      renderRemoteSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey],
        {url:mainEl.data('upc-typeahead-url'), data: configureDataCallback({paramKey: 'likeUpc'}), minLengthOfChars:3}, value);
    }
  });
}

export function getDropDownDisplayValue(mainEl, crpKey, paramDetails, dataKey) {
  let dddetails = getCrpDropDownDetails(mainEl, crpKey, paramDetails);
  let retval = '';

  if (crpKey == 'DATE_RANGE') {
    if (dataKey == "24_HOURS") {
      retval = "Last 24 Hours";
    } else if (dataKey == "48_HOURS") {
      retval = "Last 48 Hours";
    } else if (dataKey == "7_DAYS") {
      retval = "Last 7 Days";
    } else if (dataKey == "30_DAYS") {
      retval = "Last 30 Days";
    } else if (dataKey == "90_DAYS") {
      retval = "Last 90 Days";
    }
  } else {
    if (dddetails) {
      const dataValues = dataKey.split(',');
      dataValues.forEach(function(val){
        dddetails.data.forEach(function(record, index) {
          if (record[dddetails.keyName] == val){
            if(retval.length > 0) retval += ", ";
            retval += record[dddetails.valName];
          }
        });
      });
    }else{
      retval = dataKey;
    }
  }

  return retval;
}

function getCrpDropDownDetails(mainEl, crpKey, paramDetails) {
  let retval = null;

  if (crpKey === 'WAREHOUSE' || crpKey === 'DESTINATION_FACILITY' || crpKey === 'WAREHOUSE_REQ') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('facilities');
    retval.keyName = 'facCode';
    retval.valName = 'facName';
  } else if(crpKey === 'DATE_RANGE_TYPE') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('date-range-types');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmMeaning';
  } else if(crpKey === 'WAREHOUSE_BREAKDOWN') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('facilities-with-breakdown');
    retval.keyName = 'facCode';
    retval.valName = 'facName';
  } else if (crpKey === 'RMA_STATUS') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('rma-statuses');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmMeaning';
  } else if (crpKey === 'RMA_ADDRESS') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('rma-addresses');
    retval.keyName = 'cadId';
    retval.valName = 'cadLocationName';
  } else if (crpKey === 'AGING_DAYS') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('aging-days');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmMeaning';
  } else if (crpKey === 'RETAILER_ID_REQ') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('retailers');
    retval.keyName = 'rtlId';
    retval.valName = 'rtlName';
  } else if (crpKey === 'CHANNELS') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('channels');
    retval.keyName = 'parId';
    retval.valName = 'parName';
  } else if (crpKey === 'ADDRESS_TYPES') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('address-types');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmMeaning';
  } else if (crpKey === 'CREDIT_TYPES') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('credit-types');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmMeaning';
  } else if (crpKey === 'ATT_WS_TYPES') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('att-ws-types');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmMeaning';
  } else if (crpKey === 'ATT_DESTINATIONS') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('att-des-types');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmMeaning';
  } else if (crpKey === 'ORDER_STATUS') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('order-status');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmValue';
  } else if (crpKey === 'WORK_ORDER_STATUS') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('work-order-status');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmValue';
  } else if (crpKey === 'INCLUDE_INVENTORY') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('inventory');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmMeaning';
  } else if (crpKey === 'ITEM_STATUS') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('item-status');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmValue';
  } else if (crpKey === 'CATEGORY') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('item-categories');
    retval.keyName = 'catId';
    retval.valName = 'catName';
  } else if (crpKey === 'STOCK_LEVEL') {
    retval = {};
    retval.detail = paramDetails[crpKey];
    retval.data = mainEl.data('stock-level');
    retval.keyName = 'cdmValue';
    retval.valName = 'cdmMeaning';
  }

  return retval;
}

function renderInputParam(appendTo, key, name, value='') {
  let inputParam = $(render(
    require("./html/inputParam.html"), {
      key: key,
      name: name,
      value: value
    }
  ));
  inputParam.appendTo(appendTo);
}

function renderDropDownParam(appendTo, key, name, data, param, display, value='%', hasAll=true) {
  let dropDownParam = $(render(
    require("./html/dropDownParam.html"), {
      key: key,
      name: name,
      hasAll: hasAll
    }
  ));
  dropDownParam.appendTo(appendTo);
  let $select2 = dropDownParam.find('select.select2-select');

  $select2.select2();

  setOptionsForSelect({
    selectElement: $select2,
    list: data,
    valueDataKey: param,
    textDataKey: display,
    initialSelectValue: value
  });
}

function renderSplitParam(appendTo, key, name, options={}, data=[], displayId='', displayText='', value='') {
  let hasInitialValue = false;
  let values = [];
  if(value != null && value.length > 0 && value != '%'){
    hasInitialValue = true;
    values = value.split(',');
  }

  let splitParam = $(render(
    require("./html/splitParam.html"), {
      key: key,
      name: name,
      hasInitialValue: hasInitialValue,
      values: ''
    }
  ));

  splitParam.appendTo(appendTo);

  const $toggler = splitParam.find(`.${key}-toggler`);
  const $typeAhead = splitParam.find(`#${key}-values`);

  let initialValue = (hasInitialValue) ? '#' : '%';

  const btnGrp = new QuickBtnGroup($toggler, {
    initialActiveKey: initialValue,
    distributeWidth: true,
    onBtnClick : function(obj){
      if(obj.btnKey === '#'){
        $typeAhead.parent().removeClass("hidden");
      }else{
        $typeAhead.val('').trigger('change');
        $typeAhead.parent().addClass("hidden");
      }
    }
  });
  btnGrp.init();

  let dataArr = data;
  if(displayId != null && displayId.length > 0){
    dataArr = _.map(data, function(el){
      return { id : el[displayId],  text: el[displayText] };
    });
  }

  instantiateTypeAhead($typeAhead, options, name, dataArr);

  if(!hasInitialValue){
    $typeAhead.parent().addClass("hidden");
  }else{
    $typeAhead.val(values).trigger('change');
  }
}

function renderDateRangeParam(appendTo, value='24_HOURS', dateRange1='', dateRange2='', showCustom=false) {
  let dateRangeParam = $(render(
    require("./html/dateRangeParam.html"), {
      allowCustomDateRange: showCustom,
      dropDownValue: value,
      dateRange1: dateRange1,
      dateRange2: dateRange2
    }
  ));

  dateRangeParam.appendTo(appendTo);

  let $select2 = dateRangeParam.find('select.select2-select');
  $select2.select2();

  function checkDisplayDateRangeSelector() {
    if (this.value === 'customDate') {
      appendTo.find("#customDateRangeFields").show();

      appendTo.find("#DATE_RANGE1").datepicker({
        todayBtn: "linked",
        keyboardNavigation: false,
        autoclose: true
      });

      appendTo.find("#DATE_RANGE2").datepicker({
        todayBtn: "linked",
        keyboardNavigation: false,
        autoclose: true
      });
      $(".create-schedule-btn-w-params").attr('disabled',true);
      $(".cannot-schedule-custom-date-warning").removeClass('hide');
    } else {
      appendTo.find("#customDateRangeFields").hide();
       $(".create-schedule-btn-w-params").attr('disabled',false);
       $(".cannot-schedule-custom-date-warning").addClass('hide');
    }
  }
  let dateRangeSelector = appendTo.find("#DATE_RANGE");
  dateRangeSelector.on("change", checkDisplayDateRangeSelector);
  dateRangeSelector.trigger("change");
}

function renderDateRangeTypeParam(appendTo, key, name, options=[], value='') {

  const optionsHtml = _.map(options, (el, index)=>{
    let displayClass = '';
    let activeClass = '';

    if(index === 0){
      displayClass = 'first-child';

      if(value === ''){
        activeClass = 'active';
      }
    }

    if(el.cdmValue === value){
        activeClass = 'active';
      }

    if(index === (options.length - 1)){
      displayClass = 'last-child';
    }

    return render(require("./html/dateRangeOption.html"),{
      display: el.cdmMeaning,
      value: el.cdmValue,
      displayClass: displayClass,
      activeClass: activeClass
    })
  }).join("");
  

  let dateRangeTypeParam = $(render(
    require("./html/dateRangeTypeParam.html"), {
      key: key,
      name: name,
      value: value,
      options: optionsHtml
    }
  ));

  dateRangeTypeParam.appendTo(appendTo);

  const $toggler = dateRangeTypeParam.find(`.date-range-type-toggler`);

  const btnGrp = new QuickBtnGroup($toggler, {
    initialActiveKey: value,
    distributeWidth: true
  });
  btnGrp.init();
}

const select2AjaxDefaults = {
  dataType: 'json',
  delay: 250,
  processResults: function (data, params) {
    params.page = params.page || 1;
    return {
      results: data,
      pagination: {
        more: (params.page * 20) < data.total_count
      }
    };
  },
  cache: true
};

function configureDataCallback({paramKey}){
  return function(params){
    return {
      [paramKey] : params.term
    };
  }
}

function renderRemoteSplitParam(appendTo, key, name, options={}, value='') {
  let hasInitialValue = false;
  let values = [];
  if(value != null && value.length > 0 && value != '%'){
    hasInitialValue = true;
    values = value.split(',');
  }

  let splitParam = $(render(
    require("./html/splitParam.html"), {
      key: key,
      name: name,
      hasInitialValue: hasInitialValue,
      values: values
    }
  ));

  splitParam.appendTo(appendTo);

  const $toggler = splitParam.find(`.${key}-toggler`);
  const $typeAhead = splitParam.find(`#${key}-values`);

  let initialValue = (hasInitialValue) ? '#' : '%';

  const btnGrp = new QuickBtnGroup($toggler, {
    initialActiveKey: initialValue,
    distributeWidth: true,
    onBtnClick : function(obj){
      if(obj.btnKey === '#'){
        $typeAhead.parent().removeClass("hidden");
      }else{
        $typeAhead.val('').trigger('change');
        $typeAhead.parent().addClass("hidden");
      }
    }
  });
  btnGrp.init();

  instantiateRemoteTypeAhead($typeAhead, options, name);

  if(!hasInitialValue){
    $typeAhead.parent().addClass("hidden");
  }else{
    $typeAhead.val(values).trigger('change');
  }
}

function instantiateRemoteTypeAhead(el, options, name = "") {
  el.select2({
    ajax: {
        ...select2AjaxDefaults,
        url:options.url,
        data: options.data
        },
      minimumInputLength: options.minLengthOfChars,
      placeholder: `Type ${name}`,
      width: '100%'
  });
}

function instantiateTypeAhead(el, options = {}, name = "", data = []) {
  const $options = $.extend({
    multiple: true,
    placeholder: `Type ${name}`,
    tags: false,
    data: data,
    width: '100%'
  }, options)
  const typeAhead = el.select2($options);
}



// WEBPACK FOOTER //
// ./src/pages/report/lookup/reportsUtil.js